// extracted by mini-css-extract-plugin
export var cardTitle = "product-pros-cons-module--cardTitle--14434";
export var cons = "product-pros-cons-module--cons--ea74e";
export var description = "product-pros-cons-module--description--6a7ea";
export var divider = "product-pros-cons-module--divider--1e8ee";
export var genericContainer = "product-pros-cons-module--genericContainer--7faf3";
export var gridContainer = "product-pros-cons-module--gridContainer--e074c";
export var gridStaticContainer = "product-pros-cons-module--gridStaticContainer--2ed9c";
export var item = "product-pros-cons-module--item--30939";
export var priceButton = "product-pros-cons-module--priceButton--552a8";
export var productImg = "product-pros-cons-module--productImg--10488";
export var pros = "product-pros-cons-module--pros--fb4c2";
export var prosConsContainer = "product-pros-cons-module--prosConsContainer--279f2";
export var prosConsDetails = "product-pros-cons-module--prosConsDetails--32834";
export var prosConsLists = "product-pros-cons-module--prosConsLists--5760b";